'use strict';

/**
 * @ngdoc service
 * @name thothApp.services:GoogleCalendarEvents
 * @description
 * # GoogleCalendarEvents
 * Trae y parsea los eventos de Google Calendar para importarlos al SIA.
 * El parseo se extrajo de showGoogleCalendarCtrl sin cambiar comportamiento.
 */
angular.module('thothApp.services')
  .factory('GoogleCalendarEvents', [
    '$window', '$q', 'toaster', 'Project', 'Client', 'ProductCatalog',
    'SearchClientsAndProspects', 'ActivityTypeCatalog',
    function ($window, $q, toaster, Project, Client, ProductCatalog,
              SearchClientsAndProspects, ActivityTypeCatalog) {

    var API_URL = 'https://www.googleapis.com/calendar/v3/calendars/primary/events/';

    var ACTION_TYPES = [
      { id: 'project', name: 'Proyecto', summaryName: 'P' },
      { id: 'support', name: 'Soporte', summaryName: 'S' },
      { id: 'quote', name: 'Propuesta / Comercial', summaryName: 'PC' },
      { id: 'rh', name: 'Recursos Humanos', summaryName: 'RH' },
      { id: 'vacation', name: 'Vacaciones / Incapacidades', summaryName: 'VI' }
    ];

    var CLASSIFICATION_FIELDS = [
      { origKey: 'original_action_type',              currKey: 'actionType',            apiKey: 'action_type' },
      { origKey: 'original_project_id',               currKey: 'projectId',             apiKey: 'project_id' },
      { origKey: 'original_ownerable_id',             currKey: 'clientId',              apiKey: 'ownerable_id' },
      { origKey: 'original_ownerable_type',           currKey: 'ownerableType',         apiKey: 'ownerable_type' },
      { origKey: 'original_activity_type_catalog_id', currKey: 'activityTypeCatalogId', apiKey: 'activity_type_catalog_id' },
      { origKey: 'original_product_catalog_id',       currKey: 'productId',             apiKey: 'product_catalog_id' }
    ];

    function calendarEventMetadata(event) {
      return {
        organizer:   event.organizer ? event.organizer.email : null,
        hangoutLink: event.hangoutLink || null,
        summary:     event.summary    || null,
        status:      event.status     || null,
        htmlLink:    event.htmlLink   || null,
        created:     event.created    || null
      };
    }

    function originalClassification(detail) {
      return {
        original_action_type:              detail.actionType            || null,
        original_project_id:               detail.projectId             ? Number(detail.projectId)             : null,
        original_ownerable_id:             detail.clientId              ? Number(detail.clientId)              : null,
        original_ownerable_type:           detail.ownerableType         || null,
        original_activity_type_catalog_id: detail.activityTypeCatalogId ? Number(detail.activityTypeCatalogId) : null,
        original_product_catalog_id:       detail.productId             ? Number(detail.productId)             : null,
        captured_at: new Date().toISOString()
      };
    }

    // String(null) daria "null" y se veria como un cambio donde no hay ninguno.
    function normalizeClassificationValue(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      var number = Number(value);
      return isNaN(number) ? String(value) : number;
    }

    // null cuando el evento no trae foto original: no es un evento fresco de
    // Google y no se le debe mandar metadata de clasificacion al API.
    function classificationChanges(event) {
      var original = event._originalClassification;
      if (!original) {
        return null;
      }

      var now = new Date().toISOString();
      var changes = [];

      CLASSIFICATION_FIELDS.forEach(function (field) {
        var from = normalizeClassificationValue(original[field.origKey]);
        var to   = normalizeClassificationValue(event[field.currKey]);
        if (from !== to) {
          changes.push({ field: field.apiKey, from: from, to: to, changed_at: now });
        }
      });

      return changes;
    }

    function findCatalogId(catalogs, rawSummary) {
      if (!rawSummary) {
        return null;
      }

      var summary = rawSummary.toUpperCase().trim();
      var catalog = (catalogs || []).find(function (item) {
        return item.summaryName === summary || item.summaryExtendedName === summary;
      });

      return catalog ? catalog.id : null;
    }

    // Busca el proyecto por su codigo, tolerando el prefijo SCISA_ y los ceros
    // de la izquierda con que la gente lo escribe en Google.
    function searchProject(searchQuery) {
      if (!searchQuery) {
        return $q.resolve(null);
      }

      var normalized = String(searchQuery).replace(/^SCISA_0/, '').replace(/^0+/, '').trim();

      return Project.searchWithCache(normalized).then(function (projects) {
        var exact = projects.find(function (project) {
          return String(project.project_code).replace(/^SCISA_0/, '').replace(/^0+/, '').trim() === normalized;
        });

        if (!exact) {
          return null;
        }

        return {
          client_id: exact.client_id,
          client_name: exact.client_name,
          id: exact.id,
          name: exact.name,
          project_code: exact.project_code
        };
      });
    }

    // El producto se compara exacto contra los que tiene asignados el cliente.
    function searchClientProduct(searchQuery, productName) {
      if (!searchQuery) {
        return $q.resolve(null);
      }

      return Client.index({ params: { search: searchQuery } }).then(function (response) {
        var client = response.data.clients[0];
        if (!client) {
          return null;
        }

        var product = client.client_product_catalogs.find(function (item) {
          return item.product_catalog_name === productName;
        });

        return {
          client_id: client.id,
          client_name: client.name,
          product_id: product ? product.product_catalog_id : null
        };
      });
    }

    function searchClientOrProspect(searchQuery, productName) {
      if (!searchQuery) {
        return $q.resolve(null);
      }

      var params = { params: { search: searchQuery } };

      return SearchClientsAndProspects.index(params).then(function (response) {
        var found = [].concat(response.data[0] || [], response.data[1] || []);

        return ProductCatalog.index({ params: { search: productName } }).then(function (productResponse) {
          var product = productResponse.data.products[0];
          if (!product) {
            toaster.pop('error', 'Actividad', 'Revisar las actividades producto no encontrado ');
            throw new Error('Producto no encontrado');
          }

          if (found.length === 0) {
            return null;
          }

          var first = found.find(function (item) { return item.name === searchQuery; }) || found[0];

          if (first.search_type !== 'Client') {
            return {
              client_id: first.id,
              client_name: first.name,
              CorP: first.search_type,
              product_id: product.id
            };
          }

          return Client.index(params).then(function (clientResponse) {
            var owned = clientResponse.data.clients[0].client_product_catalogs.find(function (item) {
              return item.product_catalog_name === productName;
            });

            return {
              client_id: first.id,
              client_name: first.name,
              CorP: first.search_type,
              product_id: owned ? owned.product_catalog_id : null
            };
          });
        });
      }).catch(function (error) {
        if (error && error.message !== 'Producto no encontrado') {
          toaster.pop('error', 'Actividad', 'Revisar las actividades del Google Calendar ');
        }
        throw error;
      });
    }

    // Las busquedas se pueden sustituir para probar sin pegarle al API.
    function resolveDeps(deps) {
      deps = deps || {};
      return {
        RRule: deps.RRule,
        actionTypes: deps.actionTypes || ACTION_TYPES,
        catalogsSummary: deps.catalogsSummary || ActivityTypeCatalog.getActivityTypesCatalogSummary(),
        projectSearch: deps.projectSearch || searchProject,
        clientProductSearch: deps.clientProductSearch || searchClientProduct,
        clientOrProspectSearch: deps.clientOrProspectSearch || searchClientOrProspect
      };
    }

    function actionTypeId(deps, titleType, event) {
      var found = (deps.actionTypes || ACTION_TYPES).find(function (type) {
        return type.summaryName === titleType;
      });
      return found ? found.id : event.actionType;
    }

    function occurrenceAt(date, dateTime) {
      var reference = new Date(dateTime);
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(),
                      reference.getHours(), reference.getMinutes());
    }

    function titleParts(event) {
      if (!event.summary || !event.summary.includes('|')) {
        return null;
      }
      var parts = event.summary.split('|');
      return { parts: parts, type: parts[0].trim().toUpperCase() };
    }

    function unclassifiedDetail(event) {
      var detail = {
        summary: event.summary,
        start: event.start.dateTime,
        end: event.end.dateTime,
        actionType: null,
        clientId: null,
        clientName: null,
        ownerableType: null,
        description: event.summary,
        googleCId: event.id,
        id: event.id,
        isValidate: false,
        needsClassification: true,
        isRecurring: false,
        google_calendar_event: calendarEventMetadata(event),
        attendees: event.attendees || []
      };
      detail._originalClassification = originalClassification(detail);
      return detail;
    }

    function unclassifiedRecurringDetails(event, dates) {
      return dates.map(function (date, recurrenceIndex) {
        var detail = {
          summary: event.summary,
          isRecurring: true,
          start: occurrenceAt(date, event.start.dateTime),
          end: occurrenceAt(date, event.end.dateTime),
          actionType: null,
          clientId: null,
          clientName: null,
          ownerableType: null,
          description: event.summary,
          googleCId: event.id,
          id: event.id + '-' + recurrenceIndex,
          isValidate: false,
          needsClassification: true,
          google_calendar_event: calendarEventMetadata(event),
          attendees: event.attendees || []
        };
        detail._originalClassification = originalClassification(detail);
        return detail;
      });
    }

    async function parseEvent(event, rawDeps) {
      var deps = resolveDeps(rawDeps);
      var title = titleParts(event);
      var detail;

      if (title && title.type === 'P' && title.parts.length === 4) {
        var projectCatalogId = findCatalogId(deps.catalogsSummary, title.parts[2]);
        var projectDescription = title.parts[3].trim();
        var project = await deps.projectSearch(title.parts[1].trim());

        detail = {
          summary: event.summary,
          start: event.start.dateTime,
          end: event.end.dateTime,
          actionType: actionTypeId(deps, title.type, event) || null,
          clientId: project && project.client_id ? project.client_id : null,
          clientName: project && project.client_name ? project.client_name : null,
          ownerableType: 'Client',
          description: projectDescription || null,
          googleCId: event.id,
          id: event.id,
          isValidate: !!(project && project.client_id && project.id && projectDescription),
          isRecurring: false,
          projectId: project && project.id ? project.id : null,
          projectName: project && project.name ? project.name : null,
          project_code: project && project.project_code ? project.project_code : null,
          activityTypeCatalogId: projectCatalogId || null,
          ticketId: null,
          ticketName: null,
          google_calendar_event: calendarEventMetadata(event)
        };
      } else if (title && title.type === 'S' && title.parts.length === 5) {
        var supportCatalogId = findCatalogId(deps.catalogsSummary, title.parts[3]);
        var supportDescription = title.parts[4].trim();
        var support = await deps.clientProductSearch(title.parts[1].trim(), title.parts[2].trim());

        detail = {
          summary: event.summary,
          start: event.start.dateTime,
          end: event.end.dateTime,
          actionType: actionTypeId(deps, title.type, event) || null,
          clientId: support && support.client_id ? support.client_id : null,
          clientName: support && support.client_name ? support.client_name : null,
          ownerableType: 'Client',
          description: supportDescription || null,
          googleCId: event.id,
          id: event.id,
          isValidate: !!(support && support.product_id && support.client_id && supportDescription),
          isRecurring: false,
          productId: support && support.product_id ? support.product_id : null,
          projectId: null,
          projectName: null,
          project_code: null,
          activityTypeCatalogId: supportCatalogId || null,
          ticketId: null,
          ticketName: null,
          google_calendar_event: calendarEventMetadata(event)
        };
      } else if (title && title.type === 'PC' && title.parts.length === 4) {
        var quoteDescription = title.parts[3].trim();
        var quote = await deps.clientOrProspectSearch(title.parts[1].trim(), title.parts[2].trim());

        detail = {
          summary: event.summary,
          start: event.start.dateTime,
          end: event.end.dateTime,
          actionType: actionTypeId(deps, title.type, event) || null,
          clientId: quote && quote.client_id ? quote.client_id : null,
          clientName: quote && quote.client_name ? quote.client_name : null,
          ownerableType: quote && quote.CorP ? quote.CorP : null,
          description: quoteDescription || null,
          googleCId: event.id,
          id: event.id,
          isValidate: !!(quote && quote.product_id && quote.client_id && quoteDescription),
          isRecurring: false,
          productId: quote && quote.product_id ? quote.product_id : null,
          projectId: null,
          projectName: null,
          activityTypeCatalogId: null,
          project_code: null,
          ticketId: null,
          ticketName: null,
          google_calendar_event: calendarEventMetadata(event)
        };
      } else if (title && title.type === 'RH' && title.parts.length === 2) {
        var rhDescription = title.parts[1].trim();

        detail = {
          summary: event.summary,
          start: event.start.dateTime,
          end: event.end.dateTime,
          actionType: actionTypeId(deps, title.type, event) || null,
          clientId: $window.sessionStorage.default_customer_id,
          clientName: $window.sessionStorage.default_customer_name,
          ownerableType: 'Client',
          description: rhDescription || null,
          googleCId: event.id,
          id: event.id,
          isValidate: !!rhDescription,
          isRecurring: false,
          activityTypeCatalogId: null,
          google_calendar_event: calendarEventMetadata(event)
        };
      } else {
        detail = unclassifiedDetail(event);
      }

      if (event.recurringEventId) {
        detail.eventId = event.recurringEventId;
      }
      detail.attendees = event.attendees || [];
      if (!detail._originalClassification) {
        detail._originalClassification = originalClassification(detail);
      }

      return detail;
    }

    async function parseRecurringEvent(event, rawDeps, startOfWeek, endOfWeek) {
      var deps = resolveDeps(rawDeps);
      var rule = deps.RRule.fromString(event.recurrence[event.recurrence.length - 1]);
      rule.options.dtstart = startOfWeek;
      // Horas y minutos fuera de rango. Es lo que expande hoy: corregirlos
      // cambia las ocurrencias que devuelve y con eso lo que se importa.
      rule.options.byhour = [24];
      rule.options.byminute = [60];
      rule.options.bysecond = [60];

      var dates = rule.between(startOfWeek, endOfWeek);
      var title = titleParts(event);

      // Las ramas clasificadas no ponen attendees ni _originalClassification,
      // a diferencia de parseEvent. Cambiarlo mueve la tasa de clasificacion.
      if (title && title.type === 'P' && title.parts.length === 4) {
        var projectCatalogId = findCatalogId(deps.catalogsSummary, title.parts[2]);
        var projectDescription = title.parts[3].trim();
        var project = await deps.projectSearch(title.parts[1].trim());

        return dates.map(function (date, recurrenceIndex) {
          return {
            summary: event.summary,
            start: occurrenceAt(date, event.start.dateTime),
            end: occurrenceAt(date, event.end.dateTime),
            actionType: actionTypeId(deps, title.type, event) || null,
            clientId: project && project.client_id ? project.client_id : null,
            clientName: project && project.client_name ? project.client_name : null,
            ownerableType: 'Client',
            description: projectDescription || null,
            googleCId: event.id,
            id: event.id + '-' + recurrenceIndex,
            isValidate: !!(project && project.client_id && project.id && projectDescription),
            isRecurring: true,
            projectId: project && project.id ? project.id : null,
            projectName: project && project.name ? project.name : null,
            project_code: project && project.project_code ? project.project_code : null,
            activityTypeCatalogId: projectCatalogId || null,
            ticketId: null,
            ticketName: null,
            google_calendar_event: calendarEventMetadata(event)
          };
        });
      }

      if (title && title.type === 'S' && title.parts.length === 5) {
        var supportCatalogId = findCatalogId(deps.catalogsSummary, title.parts[3]);
        var supportDescription = title.parts[4].trim();
        var support = await deps.clientProductSearch(title.parts[1].trim(), title.parts[2].trim());

        return dates.map(function (date, recurrenceIndex) {
          return {
            summary: event.summary,
            start: occurrenceAt(date, event.start.dateTime),
            end: occurrenceAt(date, event.end.dateTime),
            actionType: actionTypeId(deps, title.type, event) || null,
            clientId: support && support.client_id ? support.client_id : null,
            clientName: support && support.client_name ? support.client_name : null,
            ownerableType: 'Client',
            description: supportDescription || null,
            googleCId: event.id,
            id: event.id + '-' + recurrenceIndex,
            isValidate: !!(support && support.product_id && support.client_id && supportDescription),
            isRecurring: true,
            productId: support && support.product_id ? support.product_id : null,
            projectId: null,
            projectName: null,
            project_code: null,
            activityTypeCatalogId: supportCatalogId || null,
            ticketId: null,
            ticketName: null,
            google_calendar_event: calendarEventMetadata(event)
          };
        });
      }

      if (title && title.type === 'PC' && title.parts.length === 4) {
        var quoteDescription = title.parts[3].trim();
        var quote = await deps.clientOrProspectSearch(title.parts[1].trim(), title.parts[2].trim());

        return dates.map(function (date, recurrenceIndex) {
          return {
            summary: event.summary,
            start: occurrenceAt(date, event.start.dateTime),
            end: occurrenceAt(date, event.end.dateTime),
            actionType: actionTypeId(deps, title.type, event) || null,
            clientId: quote && quote.client_id ? quote.client_id : null,
            clientName: quote && quote.client_name ? quote.client_name : null,
            ownerableType: quote && quote.CorP ? quote.CorP : null,
            description: quoteDescription || null,
            googleCId: event.id,
            id: event.id + '-' + recurrenceIndex,
            isValidate: !!(quote && quote.product_id && quote.client_id && quoteDescription),
            isRecurring: true,
            productId: quote && quote.product_id ? quote.product_id : null,
            projectId: null,
            projectName: null,
            project_code: null,
            activityTypeCatalogId: null,
            ticketId: null,
            ticketName: null,
            google_calendar_event: calendarEventMetadata(event)
          };
        });
      }

      if (title && title.type === 'RH' && title.parts.length === 2) {
        var rhDescription = title.parts[1].trim();

        return dates.map(function (date, recurrenceIndex) {
          return {
            summary: event.summary,
            start: occurrenceAt(date, event.start.dateTime),
            end: occurrenceAt(date, event.end.dateTime),
            actionType: actionTypeId(deps, title.type, event) || null,
            clientId: $window.sessionStorage.default_customer_id,
            clientName: $window.sessionStorage.default_customer_name,
            ownerableType: 'Client',
            description: rhDescription || null,
            googleCId: event.id,
            id: event.id + '-' + recurrenceIndex,
            isValidate: !!rhDescription,
            isRecurring: true,
            activityTypeCatalogId: null,
            google_calendar_event: calendarEventMetadata(event)
          };
        });
      }

      return unclassifiedRecurringDetails(event, dates);
    }

    // Quita las ocurrencias repetidas de un mismo recurrente y las que ya
    // llegaron como evento propio desde Google.
    function dedupe(events) {
      return events.filter(function (event, index, all) {
        if (!event.isRecurring) {
          return true;
        }

        var first = all.findIndex(function (other) {
          return other.isRecurring &&
                 new Date(other.start).getTime() === new Date(event.start).getTime() &&
                 other.summary === event.summary;
        });

        var alreadyOwnEvent = all.some(function (other) {
          return event.googleCId === other.eventId &&
                 new Date(other.start).getDate() === new Date(event.start).getDate();
        });

        return index === first && !alreadyOwnEvent;
      });
    }

    function isImportable(event) {
      return event.status !== 'cancelled' && event.transparency !== 'transparent';
    }

    async function fetchWeek(startOfWeek, endOfWeek, deps) {
      var token = $window.localStorage.googleToken;
      var parsed = [];
      var pageToken;

      do {
        var url = API_URL + '?timeMin=' + startOfWeek.toISOString() +
                  '&timeMax=' + endOfWeek.toISOString() + '&singleEvents=true' +
                  (pageToken ? '&pageToken=' + pageToken : '');
        var response = await fetch(url, { headers: { Authorization: 'Bearer ' + token } });

        if (!response.ok) {
          // El aviso va aqui porque quien llama lo atrapa con un mensaje
          // generico que no distingue un token vencido de un error de formato.
          toaster.pop('error', 'Error al obtener eventos',
                      response.status + ' Recargue la página o inicie sesión nuevamente');
          throw new Error('Google Calendar respondio ' + response.status);
        }

        var data = await response.json();

        for (var i = 0; i < data.items.length; i++) {
          var event = data.items[i];
          if (!isImportable(event)) {
            continue;
          }

          var startTime = new Date(event.start.dateTime);
          if (event.recurrence) {
            if (startTime < endOfWeek) {
              parsed.push.apply(parsed, await parseRecurringEvent(event, deps, startOfWeek, endOfWeek));
            }
          } else if (startTime >= startOfWeek && startTime <= endOfWeek) {
            parsed.push(await parseEvent(event, deps));
          }
        }

        pageToken = data.nextPageToken;
      } while (pageToken);

      return dedupe(parsed);
    }

    return {
      ACTION_TYPES: ACTION_TYPES,
      calendarEventMetadata: calendarEventMetadata,
      originalClassification: originalClassification,
      classificationChanges: classificationChanges,
      findCatalogId: findCatalogId,
      occurrenceAt: occurrenceAt,
      unclassifiedDetail: unclassifiedDetail,
      unclassifiedRecurringDetails: unclassifiedRecurringDetails,
      parseEvent: parseEvent,
      parseRecurringEvent: parseRecurringEvent,
      dedupe: dedupe,
      fetchWeek: fetchWeek,
      searchProject: searchProject,
      searchClientProduct: searchClientProduct,
      searchClientOrProspect: searchClientOrProspect
    };
  }]);
